import React, { useEffect } from 'react';
import { PopUpContainer, PopUpContent, ButtonsContainer, Button, CheckboxContainer } from './styles.js';

export default function PopUpCheckWatched({ setShowPopUpCheckWatched, background_color, defineAsWatched, watchData, navigate, url }) {

    const handleDefineAsWatched = () => {
        defineAsWatched(watchData, watchData?.episode_details?.runtime * 60);
        setShowPopUpCheckWatched(false);
    };

    const closePopUp = () => {
        setShowPopUpCheckWatched(false);
        navigate(url);
    };

    // Salva no localStorage quando o usuário marca o checkbox
    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        localStorage.setItem("dont_show_again_mark_episode_as_watched", checked ? true : false);
    };

    return (
        <PopUpContainer background_color={background_color}>
            <PopUpContent>
                <h3>Marcar episódio como assistido?</h3>
                <span className='episode'>T{watchData?.episode_details?.season_number} / E{watchData?.episode_details?.episode_number} {watchData?.episode_details?.name ? ` - "${watchData?.episode_details?.name}"` : null }</span>
                <ButtonsContainer>
                    <Button onClick={handleDefineAsWatched}>Sim</Button>
                    <Button onClick={closePopUp}>Não</Button>
                </ButtonsContainer>
                <CheckboxContainer>
                    <input type="checkbox" id='checkbox' onChange={handleCheckboxChange} />
                    <label for="checkbox">
                        <span>Não perguntar novamente</span>
                    </label>
                </CheckboxContainer>
            </PopUpContent>
        </PopUpContainer>
    );
}
